import {useNavigate} from 'react-router-dom';

import {ActionStyle, ActionType, ButtonStyle} from 'components/design-guide';
import Action from 'components/design-guide/Action';
import {getRoute} from 'config/navigation';
import ConfirmationPrompt from 'shared/components/ConfirmationPrompt';
import FormattedMessage from 'shared/IntlFormatMessage/components/FormattedMessage';
import {GLOBAL_TRANSLATIONS} from 'shared/IntlFormatMessage/translations/globalTranslations';
import {formatHTML} from 'shared/IntlFormatMessage/utils/intl';
import {intlFormatSingleMessage} from 'shared/IntlFormatMessage/utils/intlMesssageFormat';

interface Props {
  isOpen: boolean;
  onClose(): void;
}

export const AccountAlreadyExists = ({isOpen, onClose}: Props) => {
  const navigate = useNavigate();

  const handleCancel = () => onClose();
  const handleLogin = () => {
    navigate(getRoute('/login'));
  };

  return (
    <ConfirmationPrompt
      name="account-already-exists"
      {...{isOpen}}
      title={intlFormatSingleMessage(ALREADY_EXISTS_TRANSLATIONS.ACCOUNT_ALREADY_EXISTS_TITLE)}
      message={intlFormatSingleMessage(ALREADY_EXISTS_TRANSLATIONS.ACCOUNT_ALREADY_EXISTS_MESSAGE, {...formatHTML})}
      onCancel={handleCancel}
      confirmationButton={
        <Action
          name="confirm-prompt-button"
          actionStyle={ActionStyle.BUTTON}
          styleProps={{buttonStyle: ButtonStyle.SECONDARY}}
          actionType={ActionType.ONCLICK}
          typeProps={{type: 'button', onClick: handleLogin}}>
          <FormattedMessage message={GLOBAL_TRANSLATIONS.LOGIN} />
        </Action>
      }></ConfirmationPrompt>
  );
};

const ALREADY_EXISTS_TRANSLATIONS = {
  ACCOUNT_ALREADY_EXISTS_TITLE: 'You Already Have an Online Account',
  ACCOUNT_ALREADY_EXISTS_MESSAGE:
    'Our records indicate that you have already created an online account.{br}{br}Please confirm your information was entered correctly, or call us at {contactPhone} for assistance.'
};
